var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBudgetEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 8.75,
    width: 105,
    height: 118.125,
    rx: 30.625,
    stroke: "#7663EB",
    strokeWidth: 8.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8708 26.25C94.2871 26.25 96.2871 28.222 95.8863 30.6048C95.5586 32.5527 95.0113 34.4619 94.2518 36.2954C92.9327 39.4802 90.9991 42.374 88.5616 44.8116C86.124 47.2491 83.2302 49.1827 80.0454 50.5018C76.8606 51.821 73.4472 52.5 70 52.5C66.5528 52.5 63.1394 51.821 59.9546 50.5018C56.7698 49.1827 53.876 47.2491 51.4384 44.8116C49.0009 42.374 47.0673 39.4802 45.7482 36.2954C44.9887 34.4619 44.4414 32.5527 44.1137 30.6048C43.7129 28.222 45.7129 26.25 48.1292 26.25C50.5454 26.25 52.4546 28.2385 53.0527 30.5795C53.2581 31.3835 53.5209 32.1737 53.8398 32.9438C54.7189 35.0659 56.0073 36.9942 57.6315 38.6185C59.2558 40.2427 61.1841 41.5311 63.3062 42.4102C65.4284 43.2892 67.703 43.7416 70 43.7416C72.297 43.7416 74.5716 43.2892 76.6938 42.4102C78.8159 41.5311 80.7442 40.2427 82.3685 38.6185C83.9927 36.9942 85.2811 35.0659 86.1602 32.9438C86.4791 32.1737 86.7419 31.3835 86.9473 30.5795C87.5454 28.2385 89.4546 26.25 91.8708 26.25Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetEmpty);
export default __webpack_public_path__ + "static/media/budget-empty.8d60f37adb3e8e2b453780869a65158a.svg";
export { ForwardRef as ReactComponent };